import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  useTheme
} from '@chakra-ui/react'

interface IReviewValidationModalProps {
  isOpen: boolean
  onClose: () => void
}

const ReviewValidationModal = ({ isOpen, onClose }: IReviewValidationModalProps) => {
  const { currentTheme } = useTheme()
  const primaryColor = currentTheme?.primaryColor || '#3182CE'
  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontSize="lg" lineHeight={7} color="gray.800" fontWeight={700}>
          Unable to mark/sign-off
        </ModalHeader>
        <ModalBody>
          <Text color="gray.700" fontSize="md">
            Please make sure you fully reviewed the changes by checking all the boxes.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            backgroundColor={primaryColor}
            color="white"
            fontWeight={500}
            lineHeight={6}
            border="none"
            borderRadius="6px"
            paddingY={2}
            paddingX={6}
            onClick={onClose}
            _hover={{ opacity: 0.8 }}
          >
            OK
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default ReviewValidationModal

